/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-01T17:31:37.056
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialAdjustmentApplyItem,
	listFinancialAdjustmentApplyItemInit,
	listFinancialAdjustmentApplyItemByAuthorizations,
	deleteFinancialAdjustmentApplyItem
	
} from '@api/financial/FinancialAdjustmentApplyItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialAdjustmentApplyItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialAdjustmentApplyItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialAdjustmentApplyItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialAdjustmentApplyItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialAdjustmentApplyItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialAdjustmentApplyItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialAdjustmentApplyItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialAdjustmentApplyItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
